import React from 'react';
import './RankingTable.css';

interface CourseInfo {
  course: string;
  label: string;
}

interface RowData {
  name: string;
  values: Record<string, number>;
  deltaAbs: number;
  deltaPct: number;
}

interface Scope {
  kind: string;
  label: string;
}

export interface RankingTableData {
  type: 'ranking-table';
  title: string;
  subtitle?: string;
  courses: CourseInfo[];
  rows: RowData[];
  metric?: string;
  metricLabel?: string;
  scope?: Scope;
  question?: string;
}

const RankingTable: React.FC<{ data: RankingTableData }> = ({ data }) => {
  const { title, subtitle, courses, rows, metricLabel } = data;

  const orderedCourses = [...courses].sort((a, b) => a.course.localeCompare(b.course));

  return (
    <div className="ranking-table">
      <div className="rt-header">
        {metricLabel && <span className="rt-metric-label">{metricLabel.toUpperCase()}</span>}
        <h2 className="rt-title">{title}</h2>
        {subtitle && <p className="rt-subtitle">{subtitle}</p>}
      </div>

      <div className="rt-table-wrapper">
        <table className="rt-table">
          <thead>
            <tr>
              <th className="rt-th rt-th-name">Nombre</th>
              {orderedCourses.map(c => (
                <th className="rt-th rt-th-value" key={c.course}>{c.label}</th>
              ))}
              <th className="rt-th rt-th-change">Variación</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => {
              const isNegative = row.deltaPct < 0;
              const isPositive = row.deltaPct > 0;
              return (
                <tr className="rt-row" key={idx}>
                  <td className="rt-td rt-td-name" title={row.name}>{row.name}</td>
                  {orderedCourses.map(c => (
                    <td className="rt-td rt-td-value" key={c.course}>
                      {(row.values[c.course] ?? 0).toLocaleString('es-ES')}
                    </td>
                  ))}
                  <td className="rt-td rt-td-change">
                    <span className={`rt-badge ${isNegative ? 'rt-badge-down' : isPositive ? 'rt-badge-up' : 'rt-badge-neutral'}`}>
                      {isPositive ? '▲' : isNegative ? '▼' : ''}
                      {row.deltaPct >= 0 ? '+' : ''}{row.deltaPct.toFixed(1)} %
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RankingTable;
